import React from "react";

function FormSupplierFacturas({ faturacao = [] }) {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-6">📊 Facturação Mensal</h1>

        <table className="min-w-full border border-gray-200">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="px-4 py-2">Mês</th>
              <th className="px-4 py-2">Total Facturado (€)</th>
            </tr>
          </thead>
          <tbody>
            {faturacao.map((item, index) => (
              <tr key={index} className="text-center border-t">
                <td className="px-4 py-2">{item.mes}</td>
                <td className="px-4 py-2">{item.total} €</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FormSupplierFacturas;